<template>
  <div>
    <navbar
      v-if="show"
      @toggle-sidebar="toggleSidebar = !toggleSidebar"
      :loggedInUserData="loggedInUserData"
    ></navbar>
    <div class="page-container">
      <div class="page-content">
        <sidebar
          v-if="toggleSidebar"
          :loggedInUserData="loggedInUserData"
        ></sidebar>

        <div class="content-wrapper">
          <div class="content pb-0">
            <div class="panel panel-flat" style="height: 90vh; overflow: scroll">
              <router-view @clicked="onClickChild"></router-view>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from './sidebar'
import navbar from './navbar'
import axios from 'axios'

export default {
  components: {
    sidebar: sidebar,
    navbar: navbar
  },

  created() {
    this.getUser()
  },

  data() {
    return {
      loggedInUserData: {},
      show: false,
      toggleSidebar: true
    }
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      this.show = true
    },

    getUser() {
      this.show = false
      let token = localStorage.getItem('access_token')
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
        })
        .then(() => {
          this.getLoggedInUser()
        })
    },

    onClickChild() {
      this.getUser()
    },
  },
}
</script>

<style>
.panel-flat {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pageContainer.vue